<template>
    <div class="map-container">
        <el-input placeholder="请输入内容" v-model="content" class="input-with-select" readonly="readonly">
            <el-button @click="showMap" size="mini" slot="append" icon="el-icon-location"></el-button>
        </el-input>

        <div v-if="dialogVisible" class="mask"></div> <!-- 添加蒙版 -->

        <div v-if="dialogVisible" class="map-dialog" style="height: 600px; width: 1100px;border-radius: 10px;">
            <div style="display: flex;align-items: center; justify-content: space-between;">
                <h3>{{ header }}</h3>
                <el-button @click="cancelSelection">取消</el-button>
            </div>
            <div id="amap"
                style="width: 100%; height: 530px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);background-color: #fff;">
            </div>
            <div class="map-controls">
                <!-- <el-button type="primary" @click="selectPoint">确认选择</el-button> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyMap',
    props: {
        content: String,
        initialPoint: String, // 初始点的字符串表示形式，如 "经度,纬度"
        header: {
            type: String,
            default: ''
        },
        clickable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            map: null,
            marker: null, // 用于存储标记点对象
            selectedPoint: null,
            dialogVisible: false,
            selectedLocation: this.initialPoint || ''
        };
    },
    mounted() {
    },
    methods: {
        showMap() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.initMap();
            });
        },
        initMap() {
            this.map = new AMap.Map('amap', {
                zoom: 16,
                center: this.initialPoint ? [parseFloat(this.initialPoint.split(',')[0]), parseFloat(this.initialPoint.split(',')[1])] : [117.0702181, 36.6663163], // 默认中心点位置
                // viewMode: '3D',  //2d 3d 切换
                // terrain: true,   // 开启地形图

            });

            if (this.initialPoint) {
                const [lng, lat] = this.initialPoint.split(',');
                this.selectedPoint = {
                    lng: parseFloat(lng),
                    lat: parseFloat(lat),
                };
                this.addMarker(this.selectedPoint);
            }

            if (this.clickable) {
                this.map.on('click', (e) => {
                    this.selectedPoint = {
                        lng: e.lnglat.lng,
                        lat: e.lnglat.lat,
                    };
                    this.updateMarker(this.selectedPoint);
                });
            }

        },
        addMarker(point) {
            this.marker = new AMap.Marker({
                position: new AMap.LngLat(point.lng, point.lat),
                map: this.map,
                icon: new AMap.Icon({
                    size: new AMap.Size(25, 36),
                    image: require("../assets/mark_b.png"),
                    imageSize: new AMap.Size(25, 36),
                }),
                offset: new AMap.Pixel(-12, -36),
            });
        },
        updateMarker(point) {
            if (this.marker) {
                this.marker.setPosition(new AMap.LngLat(point.lng, point.lat));
            } else {
                this.addMarker(point);
            }
        },
        selectPoint() {
            if (this.selectedPoint) {
                this.$emit('point-selected', this.selectedPoint);
                this.selectedLocation = `${this.selectedPoint.lng},${this.selectedPoint.lat}`;
            } else {
                this.$message.error('请选择一个点后再保存。');
                return;
            }
            this.marker = null;
            this.dialogVisible = false;
            this.selectedPoint = null;
            // this.selectedLocation = null;
        },
        cancelSelection() {
            this.marker = null;
            this.selectedPoint = null;
            this.$emit('cancel-selection');
            this.dialogVisible = false;
        },
    },
    watch: {
        initialPoint(newVal) {
            if (newVal) {
                const [lng, lat] = newVal.split(',');
                this.selectedLocation = newVal;
                this.updateMarker({ lng: parseFloat(lng), lat: parseFloat(lat) });
            } else if (this.initialPoint) {

            } else {
                this.selectedLocation = null;
                this.marker = null;
            }
        },
    },
};
</script>

<style scoped>
.map-dialog {
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -5%);

    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.map-container {
    position: relative;
}

.map-controls {
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 1000;
}

.mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
    /* 确保在弹出框下方 */
    display: block;
    /* 显示蒙版 */
}
</style>
